import AntSelect from 'antd/lib/select';
import { customMap, createComponent } from 'redux-form-antd';
import { wrapWithField } from '@ackee/mateus';
import { forwardRef, useRef } from 'react';

const selectFieldMap = customMap((mapProps, { input: { onBlur, value } }) => ({
    ...mapProps,
    onBlur: () => {
        onBlur(value);
    },
}));

const Select = forwardRef((props, ref) => {
    // eslint-disable-next-line react/prop-types
    const { options = [] } = props;

    const selectProps = {
        ...props,
        options: undefined,
    };

    const containerRef = useRef(null);

    return (
        <>
            <AntSelect {...selectProps} getPopupContainer={() => containerRef.current} ref={ref}>
                {options.map(option => (
                    <AntSelect.Option key={option.value.toString()} value={option.value}>
                        {option.label}
                    </AntSelect.Option>
                ))}
            </AntSelect>
            <div ref={containerRef} />
        </>
    );
});

const SelectInput = createComponent(Select, selectFieldMap);
const SelectField = wrapWithField(SelectInput);

export default SelectField;
